export default {
  FIND_ALL (state, payload) {
    state.rows = payload
  },
  ADD (state, payload) {
    state.row = payload
  },
  EDIT (state, payload) {
    state.row = payload
  },
  SAVE (state, payload) {
    state.row = null
  },
  REMOVE (state, payload) {
    state.rows = state.rows.filter(row => row.id !== payload.id)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/mutations.js